import React from 'react'
import { Tooltip } from '@mui/material'

const NavLink = (props) => {
  return (
   
    <li className={`nav-link tooltip ${props.selected}`}>
       <Tooltip  arrow title={
      <div  className="tooltiptext-nav">{props.navLinkName}</div>
    } placement="right">
      <span className={`nav-link-span ${props.selected ? "nav-link-spanSelected" : ""}`}>
        <img className='nav-link-icon' src={props.src} alt="navlink-img" />
      </span>
      {/* <span class="tooltiptext">{props.navLinkName}</span> */}
      {/* <p className="nav-link-name">{props.navLinkName}</p> */}
      </Tooltip>
    </li>
 
  )
}

export default NavLink